export enum CROSS_PLATFORM_EVENT_TYPES {
  WEBVIEW_LOADED = 'REACT_NATIVE_VIEW_LOADED',
  PRODUCT_REVIEWED = 'PRODUCT_REVIEWED',
  PASSWORD_CHANGED = 'PASSWORD_CHANGED',
  NAVIGATION = 'NAVIGATION',
  ADD_TO_WISHLIST = 'ADD_TO_WISHLIST',
  REMOVE_FROM_WISHLIST = 'REMOVE_FROM_WISHLIST',
  SWITCH_ACCOUNT_TRIGGERED = 'SWITCH_ACCOUNT_TRIGGERED', // this actually does the logout on app
}
